import React from "react";
import WorkPacketFormItemComponent from "./WorkPacketFormItem";
import { FC } from "react";
import { GeneralService } from "../../services/GeneralService";
import { groupBy } from "../../services/Helper";
import { mergeStyleSets } from "@fluentui/react";
import { useEffect } from "react";
import { useState } from "react";
import { WorkPacketFormItem } from "../../models/WorkPacket";
import { WorkPacketFormPage } from "../../models/WorkPacket";
import { WorkPacketValue } from "../../models/WorkPacket";

type IProps = {
  disabled: boolean;
  documentId?: number;
  nominationNo?: string;
  lineHandlingNo: string;
  values: WorkPacketValue[];
  generalService?: GeneralService;
  workPacketPage: WorkPacketFormPage;
};
const classes = mergeStyleSets({
  page: {
    background: "white",
    padding: "32px 16px 64px",
    maxWidth: 900,
    margin: "auto"
  }
});
const WorkPacketFormPageComponent: FC<IProps> = (props: IProps) => {
  const [groupedRow, setGroupedRow] = useState<WorkPacketFormItem[][]>([]);

  useEffect(() => {
    const _filtered = [];
    for (var field of props.workPacketPage.formFields.filter(
      (f) =>
        f.otherProperties?.nominationGroup === undefined &&
        f.otherProperties?.dataTable === undefined &&
        f.otherProperties?.panel === undefined
    )) {
      if (field.itemType === 9) {
        field.items = props.workPacketPage.formFields.filter(
          (f) => f.otherProperties?.nominationGroup === field.fieldName
        );
      } else if (field.itemType === 13) {
        field.items = props.workPacketPage.formFields.filter(
          (f) => f.otherProperties?.dataTable === field.fieldName
        );
      } else if (field.itemType === 14) {
        field.items = props.workPacketPage.formFields.filter(
          (f) => f.otherProperties?.panel === field.fieldName
        );
      }
      _filtered.push(field);
    }
    const grouped = groupBy(_filtered, "row");
    setGroupedRow(Object.values(grouped));
  }, [props.workPacketPage]);

  return (
    <div className={classes.page}>
      <div className="ms-Grid" dir="ltr">
        {groupedRow.length > 0 &&
          groupedRow.map((items: any, i: number) => (
            <RenderRow
              key={`form-row-${i}`}
              formField={items}
              values={props.values}
              disabled={props.disabled}
              documentId={props.documentId}
              nominationNo={props.nominationNo}
              generalService={props.generalService}
            ></RenderRow>
          ))}
      </div>
    </div>
  );
};
export default WorkPacketFormPageComponent;

type IRowProps = {
  disabled: boolean;
  documentId?: number;
  nominationNo?: string;
  values: WorkPacketValue[];
  generalService?: GeneralService;
  formField: WorkPacketFormItem[];
};
export const RenderRow: FC<IRowProps> = (props: IRowProps) => {
  const [items, setItems] = useState<WorkPacketFormItem[]>([]);

  useEffect(() => {
    setItems(props.formField);
  }, [props.formField]);

  return (
    <div className="ms-Grid-row" style={{ paddingBottom: 12 }}>
      {items.map((item: WorkPacketFormItem) => (
        <div
          key={`wp-field-${item.id}`}
          className={`ms-Grid-col ms-sm12 ms-md${item.colSpan}`}
          style={item.cssStyles}
        >
          <WorkPacketFormItemComponent
            item={item}
            documentId={props.documentId}
            nominationNo={props.nominationNo}
            values={props.values}
            disabled={props.disabled}
            generalService={props.generalService}
          />
        </div>
      ))}
    </div>
  );
};
